import * as Yup from "yup";

export const FLEET_VEHICLE_DAMAGE_BASIC_INFO_EDIT_FORM_SCHEMA =
  Yup.object().shape({
    name: Yup.string().required("Naziv je obavezan"),
    damageDate: Yup.date().nullable().required("Datum štete je obavezan"),
  });

export const DAMAGE_PIN_EDIT_FORM_SCHEMA = Yup.object().shape({
  name: Yup.string().required("Naziv je obavezan"),
  vehicleDamageStatusId: Yup.string().required("Status je obavezan"),
});
